<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-22 15:11:30
-->
<template>
  <div>
    <codeLogic></codeLogic>
  </div>
</template>

<script>
import { addSystemParameter } from '@/service/api/systemParameter'
import codeLogic from './modules/codeLogic'
export default {
  components: {
    codeLogic,
  },
  data () {
    return {
      // e1: 1,
      // addlist: {}, //一般资料
      // addlist2: {}//模板
    }
  },
  mounted () { },
  methods: {
    // submit (val) {
    //   // console.log(this.addlist, val);
    //   this.addlist = { function_uuid: "002", module_uuid: "002", is_used: 1, ...this.addlist }
    //   addSystemParameter({ ...this.addlist, ...val }).then(res => {
    //     if (res.code === '200') {
    //       this.$Message({ text: this.$t('message_added_successfully') })
    //       this.$router.push({
    //         name: 'emailtemplate'
    //       })
    //     } else {
    //   
    //     }
    //   })
    // }
  },
}
</script>
